import React, { useEffect, useState, useContext } from 'react'
import { CFormLabel, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react'
import LogoandFav from './LogoandFav'
import './homepage.scss'
import BannerHomePage from './BannerHomePage'
import SwimlaneHomePage from './SwimlaneHomePage'
import useAxios from 'axios-hooks'
import { TEMPLATE_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { useLocation } from 'react-router-dom'

const HomePageWeb = () => {
  const [templateConfig, setTemplateConfig] = useState({})
  const [homePageConfig, setHomePageConfig] = useState({})
  const [banners, setBanners] = useState([])
  const [swimlanes, setSwimlanes] = useState([])
  const { setLoader, accountObj } = useContext(AppContext)
  const location = useLocation()

  let isCustomTemplateAllowed = accountObj?.od_resource_allowances?.custom_template
  let isTvMobileRoute = location.pathname.includes(`/tv-mobile-apps`)
  const [activePane, setActivePane] = useState(isTvMobileRoute ? 2 : 1)

  const [{ data: templateData, loading: templateLoading }, templateDataCall] = useAxios(
    {
      url: TEMPLATE_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(templateLoading)
  }, [templateLoading])

  useEffect(() => {
    if (templateData && templateData.success) {
      let { logo, fav_icon, pages } = templateData.data
      if (pages.hasOwnProperty('home_page')) {
        let { home_page } = pages
        setHomePageConfig(home_page)
        if (home_page.hasOwnProperty('banners')) {
          setBanners(home_page.banners)
        }
        if (home_page.hasOwnProperty('swimlanes')) {
          setSwimlanes(home_page.swimlanes)
        }
      }
      setTemplateConfig({
        logo,
        fav_icon,
        pages,
      })
    }
  }, [templateData])

  useEffect(() => {
    templateDataCall()
  }, [])

  const activeTab = { color: '#1976d2', fontSize: '1.1rem', cursor: 'pointer' }
  const inActiveTab = { color: '#191818', fontSize: '1.1rem', cursor: 'pointer' }
  return (
    <div className="">
      <h2>Home Page</h2>
      <CFormLabel>Modify the Home page of your platform.</CFormLabel>
      <CNav variant="tabs">
        {!isTvMobileRoute && (
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 1 ? activeTab : inActiveTab}
              active={activePane === 1}
              onClick={() => setActivePane(1)}
            >
              {!isCustomTemplateAllowed ? 'Logo & Favicon' : 'Favicon'}
            </CNavLink>
          </CNavItem>
        )}

        {/* if not custom template then render */}
        {(!isCustomTemplateAllowed || isTvMobileRoute) && (
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 2 ? activeTab : inActiveTab}
              active={activePane === 2}
              onClick={() => setActivePane(2)}
            >
              Banner
            </CNavLink>
          </CNavItem>
        )}
        {(!isCustomTemplateAllowed || isTvMobileRoute) && (
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 3 ? activeTab : inActiveTab}
              active={activePane === 3}
              onClick={() => setActivePane(3)}
            >
              Swimlanes
            </CNavLink>
          </CNavItem>
        )}
      </CNav>
      <CTabContent>
        <CTabPane role="tabpanel" visible={activePane === 1}>
          <LogoandFav templateConfig={templateConfig} />
        </CTabPane>
        <CTabPane role="tabpanel" visible={activePane === 2}>
          <BannerHomePage
            data={banners}
            templateConfig={templateConfig}
            homePageConfig={homePageConfig}
            getTemplate={templateDataCall}
          />
        </CTabPane>
        <CTabPane role="tabpanel" visible={activePane === 3}>
          <SwimlaneHomePage
            data={swimlanes}
            homePageConfig={homePageConfig}
            templateConfig={templateConfig}
            getTemplate={templateDataCall}
          />
        </CTabPane>
      </CTabContent>
    </div>
  )
}

export default HomePageWeb
